import React from 'react'
import { VStack } from '@chakra-ui/react'
import { TagRecommendation } from '@/types'
import { RecommendationMethod } from '@/hooks/useTagRecommendations'
import { MethodSelector } from './MethodSelector'
import { TagSuggestionsList } from './TagSuggestionsList'
import { useAppTranslation } from '@/contexts/LanguageContext'

interface SimilarDocumentsTabProps {
  recommendations: TagRecommendation[]
  isLoading: boolean
  error: string | null
  method: RecommendationMethod
  onMethodChange: (method: RecommendationMethod) => void
  selectionCount: number
  onToggleTag: (tagName: string) => void
  isTagSelected: (tagName: string) => boolean
}

export function SimilarDocumentsTab({
  recommendations,
  isLoading,
  error,
  method,
  onMethodChange,
  selectionCount,
  onToggleTag,
  isTagSelected,
}: SimilarDocumentsTabProps) {
  const { t } = useAppTranslation('files')

  return (
    <VStack spacing={4} align="stretch">
      <MethodSelector
        selectedMethod={method}
        onMethodChange={onMethodChange}
        isDisabled={isLoading}
      />

      <TagSuggestionsList
        suggestions={recommendations}
        isLoading={isLoading}
        error={error}
        selectionCount={selectionCount}
        onToggleTag={onToggleTag}
        isTagSelected={isTagSelected}
        loadingText={t('similarDocumentsTab.loadingText')}
        emptyMessage={t('similarDocumentsTab.emptyMessage')}
      />
    </VStack>
  )
}
